module.exports = ":host {\n  display: block; }\n\napp-map {\n  width: 100% !important; }\n"